import { render } from "./BlankPageSales.vue?vue&type=template&id=2c9d0259&scoped=true"
import script from "./BlankPageSales.vue?vue&type=script&lang=js"
export * from "./BlankPageSales.vue?vue&type=script&lang=js"

import "./BlankPageSales.vue?vue&type=style&index=0&id=2c9d0259&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9d0259"]])

export default __exports__